<template>
    <v-container fluid grid-list-md class="buy-ip">
        <div class="headline ma-3 text-color-vip bold">
            TẠO HỖ TRỢ MỚI
        </div>
        <div class="container-tabs" v-if="maintain == 0">
            <h1 class="maintain_notice">Chức năng này đang bảo trì</h1>
        </div>
        <template v-else>
            
            <v-layout row wrap>
                <v-flex xs12>
                    <v-form ref="form_create_ticket">
                        
                        <span class="mb-2">Vấn đề cần hỗ trợ</span>
                        <v-select
                            solo
                            :items="typeList"
                            v-model="type"
                            item-text="text"
                            item-value="value"
                        ></v-select>
                        
                        <span class="mb-2">Tiêu đề hỗ trợ</span>
                        <v-text-field
                                v-model="content_question"
                                solo
                                required
                                placeholder="Nhập tiêu đề bạn muốn hỗ trợ"
                                :rules="contentQuestionRules"
                        ></v-text-field>

                        <span class="mb-2">ID bài viết nếu có</span>
                        <v-text-field
                                v-model="objectId"
                                solo
                                placeholder="ID bài viết nếu có"
                        ></v-text-field>

                        <span class="mb-2">Mô tả chi tiết</span>
                        <ckeditor :editor="editor" v-model="description" :config="editorConfig"></ckeditor>
                    </v-form>

                    <v-layout align-center row>
                        <v-flex md6>
                            <v-btn width="100%" height="50px" color="blue" class="white--text submit" 
                                   @click="postCreateTicket()">
                                Gửi hỗ trợ
                            </v-btn>
                        </v-flex>
                        <v-flex md6>
                            <v-btn router color="red" :to="{name: 'ticket_list'}" class="cancel">
                                Hủy bỏ
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </template>
    </v-container>
</template>

<script>
    import {
        CONFIG_PAGE,
        TICKET_GET_LIST,
        TICKET_POST_CREATE
    } from "~/store/actions.type";
    
    import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
    import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
    import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
    import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
    import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
    import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
    import Image from '@ckeditor/ckeditor5-image/src/image';
    import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
    import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
    import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
    import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
    import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
    import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';
    import {baseUrl} from "../../config";
    
    export default {
        components: {},
        data() {
            return {
                maintain: 1,

                typeList: [],
                type: 2,
                content_question: '',
                contentQuestionRules: [
                    v => !!v || 'Vui lòng nhập Tiêu đề'
                ],
                objectId: '',
                objectIdRules: [
                    v => !!v || 'Vui lòng nhập id bài viết'
                ],
                description: '',

                editor: ClassicEditor,
                editorConfig: {
                    plugins: [
                        EssentialsPlugin,
                        BoldPlugin,
                        ItalicPlugin,
                        LinkPlugin,
                        ParagraphPlugin,
                        Image,
                        ImageCaption,
                        ImageStyle,
                        ImageToolbar,
                        ImageUpload,
                        Alignment,
                        SimpleUploadAdapter
                    ],

                    toolbar: {
                        items: [
                            'bold',
                            'italic',
                            'link',
                            'undo',
                            'redo',
                            'bulletedList',
                            'numberedList',
                            'imageUpload',
                            'blockQuote',
                            'undo',
                            'redo'
                        ]
                    },

                    simpleUpload: {
                        uploadUrl: baseUrl+'/tickets/upload',
                    }
                }
            }
        },
        mounted() {
            this.getDataApiTicketDetail();
        },
        methods: {
            postCreateTicket(){
                let params = {
                    id: this.$route.params.id,
                    type: this.type,
                    content: this.content_question,
                    object_id: this.objectId,
                    description: this.description,
                };
                if (this.validateForm()) {
                    this.$store.dispatch(TICKET_POST_CREATE, params).then(res =>{
                        if(res) {
                            let aThis = this;
                            setTimeout(function () {
                                aThis.$router.push('/ticket/list');
                            }, 3000);
                        }
                    });
                }
            },
            validateForm() {
                let validate = false;
                validate = this.$refs.form_create_ticket.validate()
                return validate;
            },
            async getDataApiTicketDetail () {
                await this.$store.dispatch(CONFIG_PAGE).then((data) => {
                    let ticketPageStatus = data.filter(o => o.key == 'key_cp_ticket_customer');
                    this.maintain = parseInt(ticketPageStatus[0]['status']);
                });

                let data = await this.$store.dispatch(TICKET_GET_LIST, {})
                this.typeList = data.type_list;
                this.typeList.shift();
                this.type = 2
            },
        },
    };
</script>
<style lang="scss">
    @import "../../scss/main";

    .text-color {
        color: $mainColor;
        font-weight: bold;
    }
    
    form .mb-2{
        font-weight: 500;
    }
    .theme--light.v-input {
        margin-top: 5px;
    }
    
    a.cancel {
        height: 50px !important;
        width: 100% !important;
        color: #fff !important;
    }
</style>
